import styles from './muiTheme.module.scss';

const muiTheme = {
  palette: {
    primary: {
      main: styles.white,
    },
    text: {
      primary: styles.white,
    },
    type: 'dark' as const,
  },
  overrides: {
    MuiSelect: {
      icon: {
        color: styles.white,
      },
    },
    MuiTextField: {
      root: {
        width: '100%',
      },
    },
    MuiFormLabel: {
      root: {
        color: styles.white,
        '&.Mui-disabled': {
          color: styles.disabledGrey,
        },
      },
    },

    MuiOutlinedInput: {
      root: {
        '&$disabled $notchedOutline': {
          borderColor: styles.disabledGrey,
        },
      },
      disabled: {},
      notchedOutline: {
        borderColor: styles.white,
      },
    },
  },
};

export default muiTheme;
